import { images } from "../assets/img";

export const sliderItems = {
  uk: [
    {
      title: "Accounts",
      text: "Accurate, compliant accounts prepared by experienced professionals. We ensure your partnership records are clear, reliable, and ready when you need them.",
      link: "/services?scroll=limited_company",
      img: images.accounts,
    },
    {
      title: "VAT Returns",
      text: "From registration to submission, we handle all aspects of your VAT returns. Accurate, efficient, and always on time.",
      link: "/services?scroll=limited_company",
      img: images.saving,
    },
    {
      title: "Bookkeeping",
      text: "Simple, flexible bookkeeping tailored to your partnership. Stay organised and informed with up-to-date financial records and reports.",
      link: "/services?scroll=limited_company",
      img: images.bookkeeping,
    },
    {
      title: "Self Assessment",
      text: "Expert support for your Self Assessment filings. We make sure your personal and partnership submissions to HMRC are accurate, timely, and hassle-free.",
      link: "/services?scroll=sole_trader",
      img: images.selfemployed2,
    },
    {
      title: "Making Tax Digital (MTD)",
      text: "We help your business stay fully compliant with HMRC’s Making Tax Digital requirements. From digital record-keeping to submitting MTD-compatible VAT and Self Assessment filings, we make the process simple and stress-free..",
      link: "/services?scroll=sole_trader",
      img: images.vat,
    },
    {
      title: "Payroll",
      text: "Comprehensive payroll services to ensure your employees are paid accurately and on time, with all HMRC obligations met.",
      link: "/services?scroll=limited_company",
      img: images.payroll,
    },
    {
      title: "Construction Industry Scheme (CIS)",
      text: "Specialist support for contractors and subcontractors under CIS, ensuring correct deductions, submissions, and compliance with HMRC rules.",
      link: "/services?scroll=limited_company",
      img: images.service,
    },
    {
      title: "Budgeting & Forecasting",
      text: "Practical budgeting and financial forecasting to help your partnership plan ahead, manage cash flow, and make informed business decisions.",
      link: "/services?scroll=limited_company",
      img: images.budget,
    },
  ],
  ro: [
    {
      title: "Raportări Financiare Anuale",
      text: "Pregătim și depunem rapoartele financiare anuale în conformitate completă cu cerințele Companies House și HMRC. Contabilii noștri se asigură ca documentele financiare ale companiei dumneavoastră să fie întocmite cu precizie, menținând un istoric clar și complet, astfel încât afacerea să fie mereu în conformitate cu legislația în vigoare.",
      link: "/services?scroll=limited_company",
      img: images.accounts,
    },
    {
      title: "Declarații TVA",
      text: "Gestionăm integral procesul de TVA, de la înregistrare până la depunerea declarațiilor. Vă asigurăm conformitatea legală, corectitudine și profesionalism.",
      link: "/services?scroll=limited_company",
      img: images.saving,
    },
    {
      title: "Evidență Contabilă (Bookkeeping)",
      text: "Asigurăm gestionarea completă și corectă a registrelor contabile, astfel încât toate documentele să fie clare, ordonate și actualizate. Vă oferim acces rapid la informațiile financiare, transparență totală și siguranța că afacerea dumneavoastră este în permanență conformă cu reglementările.",
      link: "/services?scroll=limited_company",
      img: images.bookkeeping,
    },
    {
      title: "Declarația fiscală Self-Assessment",
      text: "Echipa noastră vă ghidează pe tot parcursul procesului, asigurându-se că fiecare informație este completă și corectă. Identificăm și utilizăm toate beneficiile fiscale aplicabile, pentru a vă optimiza obligațiile și pentru a preveni erorile ce pot duce la penalități.",
      link: "/services?scroll=sole_trader",
      img: images.selfemployed2,
    },
    {
      title: "Making Tax Digital (MTD)",
      text: "Vă ajutăm afacerea să rămână pe deplin conformă cu cerințele HMRC pentru Making Tax Digital. De la păstrarea digitală a registrelor până la depunerea documentelor compatibile MTD pentru TVA și Autoevaluare, facem procesul simplu și fără stres.",
      link: "/services?scroll=sole_trader",
      img: images.vat,
    },
    {
      title: "Salarizare (Payroll)",
      text: "Servicii complete de salarizare care asigură că angajații dumneavoastră sunt plătiți corect și la timp, îndeplinind totodată toate obligațiile legale și cerințele HMRC.",
      link: "/services?scroll=limited_company",
      img: images.payroll,
    },
    {
      title: "Declarații CIS",
      text: "Noi ne asigurăm ca impozitele și contribuțiile să fie calculate corect, raportările să fie prezentate la timp, în conformitate cu regulile Schemei Industriei Construcțiilor (CIS) și cerințele HMRC. În acest fel, eliminați riscul erorilor costisitoare și al timpului pierdut, bucurându-vă de mai multă siguranță financiară și liniște.",
      link: "/services?scroll=limited_company",
      img: images.service,
    },
    {
      title: "Bugetare și Previziuni Financiare",
      text: "Bugetare și previziuni financiare practice care susțin planificarea strategică, ajută la gestionarea eficientă a fluxului de numerar și permit luarea de decizii de afaceri informate.",
      link: "/services?scroll=limited_company",
      img: images.budget,
    },
  ],
  ru: [
    {
      title: "Ведение бухгалтерии (Bookkeeping) ",
      text: "Мы обеспечиваем полный и точный учет ваших документов, гарантируя их порядок и актуальность. Вы получаете быстрый доступ к финансовым данным и уверенность в том, что ваш бизнес полностью соответствует всем правилам и нормам.",
      link: "/services?scroll=limited_company",
      img: images.accounts,
    },
    {
      title: "Налоговая декларация Self-Assessment ",
      text: "Наша команда сопровождает вас на каждом этапе подачи декларации, проверяя точность всех данных. Мы помогаем использовать доступные налоговые льготы, чтобы оптимизировать ваши выплаты и избежать штрафов.",
      link: "/services?scroll=limited_company",
      img: images.saving,
    },
    {
      title: "Цифровой налог (Making Tax Digital — MTD) ",
      text: "Мы поможем вашему бизнесу соответствовать требованиям HMRC по цифровой отчетности. От ведения электронных реестров до подачи документов по НДС и Self-Assessment — мы сделаем этот переход простым и понятным. ",
      link: "/services?scroll=limited_company",
      img: images.bookkeeping,
    },
    {
      title: "Расчёт заработной платы (Payroll)",
      text: "Комплексные услуги по расчету заработной платы, чтобы ваши сотрудники получали оплату точно и вовремя, с полным соблюдением всех требований HMRC.",
      link: "/services?scroll=sole_trader",
      img: images.selfemployed2,
    },
    {
      title: "CIS (Строительная индустрия)",
      text: "Специализированная поддержка для подрядчиков и субподрядчиков в рамках CIS, включая корректные удержания, подачу отчетности и соблюдение требований HMRC.",
      link: "/services?scroll=sole_trader",
      img: images.vat,
    },
    {
      title: "Бюджетирование и прогнозирование",
      text: "Практическое бюджетирование и финансовое прогнозирование, помогающее вашему партнёрству планировать будущее, управлять денежными потоками и принимать обоснованные бизнес-решения.",
      link: "/services?scroll=limited_company",
      img: images.payroll,
    },
    {
      title: "Бухгалтерская отчетность",
      text: "Точная и соответствующая требованиям отчетность, подготовленная опытными специалистами. Мы обеспечиваем ясность, надежность и готовность ваших финансовых данных в любой момент.",
      link: "/services?scroll=limited_company",
      img: images.service,
    },
    {
      title: "Отчётность по НДС (VAT Returns)",
      text: "От регистрации до подачи отчетности — мы берем на себя все аспекты ваших деклараций по НДС. Точно, эффективно и всегда вовремя.",
      link: "/services?scroll=limited_company",
      img: images.budget,
    },
  ],
};

export const slidesPerDevice = {
  desktop: 4,
  laptop: 3,
  tablet: 2,
  phone: 1,
};

export const whoWeHelpItems = {
  uk: [
    {
      title: "Sole Trader",
      text: "Simplified accounting services that deliver complete support and exceptional value for your business.",
      link: "/services?scroll=sole_trader",
      icon: images.icon.help_icon1,
    },
    {
      title: "Limited Companies",
      text: "Professional accountancy services providing expert guidance and support to help your growing business thrive.",
      link: "/services?scroll=limited_company",
      icon: images.icon.help_icon2,
    },
    {
      title: "Partnership",
      text: "Professional and personal accounting services designed for growing partnerships",
      link: "/services?scroll=partnership",
      icon: images.icon.help_icon3,
    },
  ],
  ro: [
    {
      title: "Persoană Fizică Autorizată",
      text: "Servicii contabile simplificate care oferă suport complet și valoare excepțională pentru afacerea dvs.",
      link: "/services?scroll=sole_trader",
      icon: images.icon.help_icon1,
    },
    {
      title: "Societăți cu Răspundere Limitată (SRL)",
      text: "Servicii profesionale de contabilitate, oferind îndrumare și suport de specialitate pentru a ajuta afacerea dvs. să se dezvolte.",
      link: "/services?scroll=limited_company",
      icon: images.icon.help_icon2,
    },
    {
      title: "Parteneriate",
      text: "Servicii contabile profesionale și personalizate, concepute pentru dezvoltarea parteneriatelor.",
      link: "/services?scroll=partnership",
      icon: images.icon.help_icon3,
    },
  ],
  ru: [
    {
      title: "Индивидуальный предприниматель (Sole Trader)",
      text: "Упрощенные бухгалтерские услуги, обеспечивающие полную поддержку и исключительную ценность для вашего бизнеса",
      link: "/services?scroll=sole_trader",
      icon: images.icon.help_icon1,
    },
    {
      title: "Компании (Limited Companies)",
      text: "Профессиональные бухгалтерские решения, которые помогают вашему бизнесу расти и процветать. ",
      link: "/services?scroll=limited_company",
      icon: images.icon.help_icon2,
    },
    {
      title: "Партнерство (Partnership)",
      text: "Профессиональная бухгалтерия для партнёрских отношений, нацеленных на рост и успех. ",
      link: "/services?scroll=partnership",
      icon: images.icon.help_icon3,
    },
  ],
};

export const whyChooseUsItems = {
  uk: [
    {
      title: "Free consultations",
      text: "We provide a complimentary 30-minute consultation to understand your business needs and recommend tailored bookkeeping and accounting solutions.",
      icon: images.icon.free_cons,
    },
    {
      title: "Tailored Solutions",
      text: "Every business is unique. We analyze your key performance metrics and create flexible solutions that deliver accurate, reliable results.",
      icon: images.icon.tilored_sol,
    },
    {
      title: "Dedicated Support Team",
      text: "More than just accountants, our dedicated support team guides you through every financial decision with practical advice and insights to help your business succeed.",
      icon: images.icon.dedicated_sup,
    },
    {
      title: "Simplifying Accounting",
      text: "At ProTax Advisors, we make managing finances easy. From keeping your books in order to preparing for tax season and planning for growth, we handle the complexity so you can focus on your business.",
      icon: images.icon.simple_acc,
    },
  ],
  ro: [
    {
      title: "Consultanță gratuită",
      text: "Oferim o consultație gratuită de 30 de minute pentru a înțelege nevoile afacerii tale și pentru a recomanda soluții personalizate de contabilitate și evidență financiară.",
      icon: images.icon.free_cons,
    },
    {
      title: "Soluții personalizate",
      text: "Fiecare afacere este unică. Analizăm indicatorii tăi de performanță și creăm soluții flexibile care oferă rezultate precise și de încredere.",
      icon: images.icon.tilored_sol,
    },
    {
      title: "Echipă dedicată",
      text: "Mai mult decât contabili — echipa noastră de suport te ghidează în fiecare decizie financiară, oferindu-ți sfaturi practice și informații utile pentru ca afacerea ta să prospere.",
      icon: images.icon.dedicated_sup,
    },
    {
      title: "Simplificăm contabilitatea",
      text: "La ProTax Advisors, facem gestionarea finanțelor mai ușoară. De la organizarea documentelor până la pregătirea pentru sezonul de taxe și planificarea creșterii, ne ocupăm noi de complexitate, astfel încât tu să te poți concentra pe afacerea ta.",
      icon: images.icon.simple_acc,
    },
  ],
  ru: [
    {
      title: "Бесплатная консультация ",
      text: "Мы предлагаем бесплатную 30-минутную консультацию, чтобы понять потребности вашего бизнеса и порекомендовать индивидуальные решения в области бухгалтерского и финансового учета.",
      icon: images.icon.free_cons,
    },
    {
      title: "Персонализированные решения",
      text: "Каждый бизнес уникален. Мы анализируем ваши показатели эффективности и создаем гибкие решения, которые обеспечивают точные и надежные результаты.",
      icon: images.icon.tilored_sol,
    },
    {
      title: "Выделенная команда ",
      text: "Больше, чем просто бухгалтеры — наша команда поддержки сопровождает вас в каждом финансовом решении, предлагая практические советы и полезную информацию для процветания вашего бизнеса.",
      icon: images.icon.dedicated_sup,
    },
    {
      title: "Мы упрощаем бухгалтерию ",
      text: "В ProTax Advisors мы делаем управление финансами проще. От организации документов до подготовки к налоговому сезону и планирования роста — мы берем на себя все сложности, чтобы вы могли сосредоточиться на своем бизнесе.",
      icon: images.icon.simple_acc,
    },
  ],
};

export const headerItems = {
  uk: [
    {
      label: "Home",
      url: "/",
    },
    {
      label: "Our Services",
      url: "/services",
      items: [
        {
          label: "Sole Trader",
          url: "/services?scroll=sole_trader",
          id: "sole_trader",
        },
        {
          label: "Limited Company",
          url: "/services?scroll=limited_company",
          id: "limited_company",
        },
        {
          label: "Partnership",
          url: "/services?scroll=partnership",
          id: "sole_trader",
        },
      ],
    },
    {
      label: "Blog",
      url: "/blog",
    },
    {
      label: "About Us",
      url: "/about",
    },
  ],
  ro: [
    {
      label: "Acasă",
      url: "/",
    },
    {
      label: "Servicii",
      url: "/services",
      items: [
        {
          label: "Persoană Fizică Autorizată",
          url: "/services?scroll=sole_trader",
          id: "sole_trader",
        },
        {
          label: "Societăți cu Răspundere Limitată ",
          url: "/services?scroll=limited_company",
          id: "limited_company",
        },
        {
          label: "Parteneriate",
          url: "/services?scroll=partnership",
          id: "sole_trader",
        },
      ],
    },
    {
      label: "Blog",
      url: "/blog",
    },
    {
      label: "Despre Noi",
      url: "/about",
    },
  ],
  ru: [
    {
      label: "Главная",
      url: "/",
    },
    {
      label: "Услуги",
      url: "/services",
      items: [
        {
          label: "Sole Trader",
          url: "/services?scroll=sole_trader",
          id: "sole_trader",
        },
        {
          label: "Limited Company",
          url: "/services?scroll=limited_company",
          id: "limited_company",
        },
        {
          label: "Partnership",
          url: "/services?scroll=partnership",
          id: "sole_trader",
        },
      ],
    },
    {
      label: "Блог",
      url: "/blog",
    },
    {
      label: "О нас",
      url: "/about",
    },
  ],
};
